import React from 'react';

const TextSection3 = ({ title, paragraphs,marginBottom = 32  }) => {
  const containerStyle = {
    borderRadius: 20,
    padding: 0,
    marginBottom: marginBottom,
  };

  const titleStyle = {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
    color: '#212121',
  };

  const baseTextStyle = {
    fontSize: 16,
    lineHeight: '22px',
    
    color: '#212121',
    fontWeight: 400,
    marginBottom: 12,
  };

  return (
    <div style={containerStyle}>
      {title && <h3 style={titleStyle}>{title}</h3>}
      {paragraphs.map((text, index) => (
        <p key={index} style={baseTextStyle}>
          {text}
        </p>
      ))}
    </div>
  );
};

export default TextSection3;
